import React, { useState, useContext } from 'react';
import { Input, Button, Form, Row, Col, Typography, Table } from 'antd';
import numberWithSpaces from 'src/utils';
import CONSTANTS from 'src/constants';
const { Title, Text } = Typography;
import { BankContext } from 'src/containers/Dashboard/Tamaa/BankBalance';

const style = {
	border: 'none',
	backgroundColor: 'transparent',
	outline: 'none',
	color: '#00C68E'
}

function ChangeBalanceBankForm({ form, action, loading, data }) {

	const {
		setBalanceBank
	} = useContext(BankContext);

	const [edit, isEdit] = useState(false);
	const onCancel = () => {
		isEdit(false)
		form.setFields({
			newBankBalance: undefined
		})
	}

	const submit = () => {
		form.validateFieldsAndScroll((err, values) => {
			if (!err) {
				action(payload, form, onCancel);
			}
		})
	}

	const beforeUpdateBalance = (value) => {
		isEdit(false);
		setBalanceBank(value)
	}

	const { getFieldDecorator } = form;

	const availableBalance = data.length == 0 ? 0 : data[0].BankBalance - data[0].UnpaidBalance

	return (
		<Row type="flex" gutter={24}>
			<Col>
				<Form hideRequiredMark={true} >
					<Table
						columns={[
							{
								title: 'Solde bancaire',
								dataIndex: 'BankBalance',
								key: 'BankBalance',
								render: (a, b) => (
									<Form.Item style={{ marginBottom: 0 }}>
										{getFieldDecorator('newBankBalance',
											{
												initialValue: edit == false ? numberWithSpaces(a) : a
											})(
												<Input
													style={!edit ? style : {}}
													readOnly={!edit}
												/>,
											)}
									</Form.Item>
								)
							},
							{
								title: 'Solde impayé',
								dataIndex: 'UnpaidBalance',
								render: (a, b) => {
									return <span style={{ color: '#00C68E' }}>{numberWithSpaces(a)}</span>;
								}
							},
							{
								title: 'Solde disponible',
								dataIndex: 'AvailableBalance',
								render: (a, b) => {
									return <span style={{ color: '#00C68E' }}>{numberWithSpaces(availableBalance)}</span>;
								}
							},
							{
								title: 'Actions',
								dataIndex: 'Actions',
								render: (a, b) => (
									!edit
										? <Button onClick={() => isEdit(true)} icon="form" type="link">Modifier</Button>
										: (
											<Row type="flex" >
												<Col><Button onClick={onCancel}>Annuler</Button></Col>
												<Col><Button loading={loading} onClick={() => beforeUpdateBalance(newBankBalance.value)} type="primary">Sauvegarder</Button></Col>
											</Row>
										)
								)
							}
						]}

						dataSource={data}
						pagination={false}
						footer={
							() => data.map((e) => {
								return <>
									<Title style={{ color: '#00C68E', fontSize: 14 }}>
										Total: {numberWithSpaces(e.BankBalance + e.UnpaidBalance) + ' ' + CONSTANTS.CURRENCY}
									</Title>
								</>
							})
						}
					>
					</Table>

				</Form>
			</Col>
		</Row>
	)
}

export default Form.create()(ChangeBalanceBankForm);